import { FC, ReactNode, useContext } from "react";
import { Layout } from "antd";
import Sidebar from "./SideBar";
import Content from "./Content";
import Footer from "./Footer";

interface SidebarLayoutProps {
  children?: ReactNode;
}

const SidebarLayout: FC<SidebarLayoutProps> = () => {
  return (
    <Layout style={{ minHeight: "100vh",}}>
      <Sidebar/>
      <div
        style={{
          flex: 1,
          overflowX: "auto",
          padding: "0px 20px",
        }}
      >
        <Content />
        <Footer />
      </div>
    </Layout>
  );
};

export default SidebarLayout;
